import {useEffect} from "react";
import workspace from "../../sqft/components/canvas/core/workspace";
import {detectSlabConflicts} from "../../sqft/components/popup/modalFix/slabFix/slabModeConflictHelper";
import {useAppDispatch, useAppSelector} from "../../../storeHooks";
import {
  setWizardConflictSteps
} from "../../../actions/wizardFunctions";
import {setSQFTCartItemsToAdd} from "../../../actions/sqftResourceFunctions";
import {addUUIDToCartItems, computeAddedFeatures} from "./utils/computeAddedFeatures";
import {
  checkWizardConflictingSteps
} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctionsConflictingLogic";
import {SQFT_FEATURES} from "../../sqft/constants";
import {setSqftSlabConflicts} from "../../../actions/sqftSlabFunctions";

/**
 * For active quote
 * @param shouldRebuild
 * @param parentsLists
 */
export default function useSetSqftConflictItems({
                                                  shouldRebuild,
                                                  parentsLists}) {

  const dispatch = useAppDispatch();

  const { sqftCartItems } = useAppSelector(state => state.sqftResourceState);
  const { cartItems } = useAppSelector(state => state.cartState);
  const { activeQuoteIndex } = useAppSelector(state => state.quotesState);

  const checkForConflictSteps = () => {

    dispatch(setSQFTCartItemsToAdd([]));
    dispatch(setWizardConflictSteps([]));

    for (const parentsList of parentsLists) {
      const isActiveQuote = parentsList.quoteIndex === activeQuoteIndex;
      if (!isActiveQuote) {
        continue
      }

      const {addedFeatures} = computeAddedFeatures([parentsList], []);
      const tempCartItems = addUUIDToCartItems(addedFeatures);
      const cartItemsWithoutSQFTFeatures = cartItems.filter(cartItem => !cartItem.sqftIds?.length && !cartItem.sqftId);
      const cartItemsAndSQFTTempCartItems = [...tempCartItems, ...cartItemsWithoutSQFTFeatures];
      console.log("tempCartItems", tempCartItems);
      console.log("cartItemsAndSQFTCartItems", cartItemsAndSQFTTempCartItems);
      const cartItemsAndSQFTTempCartItemsWithoutSlabs = cartItemsAndSQFTTempCartItems.filter(cartItem => {
        if (cartItem.currentQuote !== activeQuoteIndex) {
          return false
        }
        return cartItem.partId !== SQFT_FEATURES.slabs
      });

      let {wizardConflictingSteps} = checkWizardConflictingSteps(cartItemsAndSQFTTempCartItemsWithoutSlabs);

      // 1.) Resolve wizard conflicts
      if (wizardConflictingSteps?.length > 0) {
        wizardConflictingSteps = wizardConflictingSteps?.map(confStep => {
          if ((!confStep.wizardGroupId || !Number.isInteger(confStep.stepIndex)) && confStep.cartFeature) {
            const alreadyAddedFeature = sqftCartItems.find(oldCartItem => {
              return oldCartItem?.cartFeature?.dbFeature?.id === confStep.cartFeature.dbFeature?.id
            });
            if (alreadyAddedFeature && alreadyAddedFeature.fromWizardGroupId) {
              confStep.wizardGroupId = alreadyAddedFeature.fromWizardGroupId;
              confStep.stepIndex = alreadyAddedFeature.fromWizardStep;
            }
          }
          delete confStep.cartFeature; // no need to keep it there, we have cartItemId if needed
          return confStep;
        });
        for (const tempCartItem of tempCartItems) {
          const confStep = wizardConflictingSteps?.find(confStep => confStep.cartItemId === tempCartItem.id)
          if (confStep) {
            tempCartItem.fromWizardGroupId = confStep.wizardGroupId
            tempCartItem.fromWizardStep = confStep.stepIndex
          }
        }
        dispatch(setWizardConflictSteps(wizardConflictingSteps));
        dispatch(setSQFTCartItemsToAdd(tempCartItems));
        //todo we need to update cart item ids somehow otherwise we we are forced to used cartItemSignature
        //handleOpenModalFix({changeWizardStepRoute, wizardConflictingSteps, intl});
      }

      const shapeIdsWithConflict = !wizardConflictingSteps?.length ? detectSlabConflicts() : [];
      dispatch(setSqftSlabConflicts(shapeIdsWithConflict));

      console.log("wizardConflictingSteps", wizardConflictingSteps);
    }
  };

  useEffect(() => {
    if (shouldRebuild && workspace.intl && parentsLists.length > 0) {
      checkForConflictSteps();
    }
    return () => {
      dispatch(setSqftSlabConflicts([])); // clear state on unmount
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldRebuild, parentsLists]);

  return null
}
